import React from 'react'
import {Box, CircularProgress, Typography} from '@mui/material'
import AppDialog from 'src/components-new/feedback/AppDialog'
import Button from 'src/components-new/primitives/Button'

interface ConfirmGenerateFormDialogNewProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  downloading: boolean
}

/**
 * Confirms generation of the selected pharmacovigilance form. While the
 * download is in flight (`downloading`), an inline spinner + message is shown
 * next to the confirm text — the dialog itself stays open until the download
 * settles (see PharmacovigilanceTab: dialogs close on success, and on failure
 * an effect closes them so the page-level InlineMessage becomes visible).
 */
export default function ConfirmGenerateFormDialogNew({
  open,
  onClose,
  onConfirm,
  downloading,
}: ConfirmGenerateFormDialogNewProps): JSX.Element {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title="Conferma generazione Form"
      maxWidth="xs"
      actions={
        <>
          <Button variant="secondary" onClick={onClose}>{'Annulla'}</Button>
          <Button variant="primary" onClick={onConfirm}>{'Ok'}</Button>
        </>
      }
    >
      <Typography variant="body2">
        {'Si desidera generare il Form di Farmaco Vigilanza selezionato?'}
      </Typography>
      {downloading && (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mt: 1.5}}>
          <CircularProgress size={16} />
          <Typography variant="body2" color="text.secondary">
            {'Generazione form in corso'}
          </Typography>
        </Box>
      )}
    </AppDialog>
  )
}
